import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import Footer from './Components/Footer';
import TopCategories from './Components/TopCategories';
import ProductSections from './Components/ProductSections';

export default function Home({ totalQuantity, setTotalQuantity }) {

  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token')

    // if (!token) {
    //   RedirectToLogin();
    //   return
    // }

  }, [])

  // function RedirectToLogin() {
  //   navigate('/login');
  // }


  return (
    <div>
      {/* <Header totalQuantity={totalQuantity} setTotalQuantity={setTotalQuantity} /> */}
      <main className="main">
        <TopCategories />
        <ProductSections totalQuantity={totalQuantity} setTotalQuantity={setTotalQuantity} />
      </main>
      <Footer />
    </div>
  );
}


